import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ACTIONS, SCREENS } from '../../../constants/Tracking';
import { AppContext, appActions } from '../../../contexts/app/context';
import { PageLayoutPropsContext } from '../../../contexts/pageLayout/PropsContext';
import { resolveCallObjectUniqueProperty } from '../../../utils/callObject';
import { buildUrlFilters } from '../../../utils/helpers';
import { generateCallsDirectLink, getDraftMeetingPlannerUrl } from '../../../utils/urls';
import { ExpandableSection } from './PastMeetingsMenu.style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PastMeetingsMenu({
  currentTabHeigth
}) {
  const {
    usageTracker,
    resetStateBetweenCallObjects,
    openUrl,
    recurringMeetings,
    portalId,
    routes,
    isPreviousMeetingsMenuOpen,
    togglePreviousMeetingsMenuOpen,
    setMeetingContext,
    meetingID,
    callObjectId
  } = useContext(PageLayoutPropsContext);
  const {
    appName
  } = useContext(AppContext);
  const history = useHistory();
  const [isPreviousMeetingsMenuAccordionOpen, setIsPreviousMeetingsMenuAccordionOpen] = useState(false);
  const [screen, setScreen] = useState('');
  const onOpenStartHandler = () => setIsPreviousMeetingsMenuAccordionOpen(true);
  const onCloseCompleteHandler = () => setIsPreviousMeetingsMenuAccordionOpen(false);
  const openPastMeeting = callObject => {
    resetStateBetweenCallObjects();
    setMeetingContext({
      canViewParticipants: true,
      meetingTopic: callObject.properties.hs_call_title,
      meetingUUID: resolveCallObjectUniqueProperty(callObject.properties),
      meetingID: callObject.properties.hs_call_meeting_id
    });
    appActions.setIsPastMeeting(true);
    togglePreviousMeetingsMenuOpen(false);
    history.push(getDraftMeetingPlannerUrl({
      callObjectId: callObject.id,
      portalId,
      draftRoute: routes.draft,
      outsideMeetingRoute: routes.outsideMeeting,
      contactsRoute: routes.contacts
    }));
    usageTracker.trackInteraction(Object.assign({
      screen
    }, ACTIONS.planner.clickPastMeetingButton));
  };
  const openAllCallObjects = () => {
    const filters = buildUrlFilters(meetingID, callObjectId);
    openUrl(generateCallsDirectLink(portalId, filters));
    usageTracker.trackInteraction(Object.assign({
      screen
    }, ACTIONS.planner.clickOpenAllCallObjects));
  };
  useEffect(() => {
    const screenName = history.location.pathname.split('/').pop();
    if (screenName) {
      setScreen(SCREENS[screenName === 'contacts' ? 'participants' : screenName]);
    }
  }, [history.location.pathname]);
  return /*#__PURE__*/_jsx(ExpandableSection, {
    currentTabHeigth: currentTabHeigth,
    isPreviousMeetingsMenuOpen: isPreviousMeetingsMenuAccordionOpen,
    children: /*#__PURE__*/_jsxs(AccordionTransition, {
      open: isPreviousMeetingsMenuOpen,
      onOpenStart: onOpenStartHandler,
      onCloseComplete: onCloseCompleteHandler,
      children: [recurringMeetings.map(callObject => /*#__PURE__*/_jsx(View, {
        marginInline: "500",
        marginBlockStart: "200",
        as: "div",
        children: /*#__PURE__*/_jsx(Button, {
          use: "link",
          responsive: false,
          onClick: () => openPastMeeting(callObject),
          truncate: true,
          "data-test-id": `${appName}-past-meeting-cta-button`,
          children: /*#__PURE__*/_jsx(TruncateString, {
            children: I18n.moment(callObject.createdAt).format('MMM D, YYYY h:mm A')
          })
        })
      }, callObject.id)), /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        responsive: false,
        onClick: openAllCallObjects,
        "data-test-id": `${appName}-all-past-meetings`,
        marginBlockStart: "300",
        marginInline: "500",
        paddingBlock: "100",
        paddingInline: "300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.header.openAllInHubSpot"
        })
      })]
    })
  });
}
export default PastMeetingsMenu;